import { render, staticRenderFns } from "./baseConf.vue?vue&type=template&id=4911ae44&scoped=true&"
import script from "./baseConf.vue?vue&type=script&lang=js&"
export * from "./baseConf.vue?vue&type=script&lang=js&"
import style0 from "./baseConf.vue?vue&type=style&index=0&id=4911ae44&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4911ae44",
  null
  
)

export default component.exports